<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { computed } from "vue";

import { useUser } from "@/composables/api/useUser";
import { redirectionToJoinFidPage } from "@/composables/useRedirection";
import { useSessionExpiredStore } from "@/stores/useSessionExpiredStore";

import Button from "@/components/ui/Button.vue";
import Dialog from "@/components/ui/Dialog.vue";

const { data: user } = useUser();

const sessionExpiredStore = useSessionExpiredStore();

const isDialogOpen = computed(() => sessionExpiredStore.$state.isSessionExpired);
</script>

<template>
  <Dialog v-model:open="isDialogOpen" :hideCloseButton="true">
    <template #content>
      <div class="flex w-full flex-col gap-8">
        <div class="flex w-full flex-col gap-6">
          <h2
            :class="
              twMerge(
                'text-galbani flex items-center gap-3 text-3xl leading-tight font-semibold',
                user?.current_mechanic === 'lactel' && 'text-lactel-blue',
              )
            "
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="size-10 shrink-0"
            >
              <g id="Frame 9813">
                <path
                  id="Vector"
                  d="M20.0016 39.9988C31.0007 39.9978 39.9992 30.9977 39.9983 19.9986C39.9975 8.99953 30.9975 0.00108203 19.9984 0.00208417C8.99927 0.00308631 0.000723469 9.00317 0.00160771 20.0023C0.00249195 31.0014 9.00248 39.9998 20.0016 39.9988Z"
                  fill="#FEB927"
                />

                <path
                  id="Vector_2"
                  d="M19.9991 12.1104L20 21.7971"
                  stroke="#214C9F"
                  stroke-width="2.4998"
                  stroke-linecap="square"
                />

                <path
                  id="Vector_3"
                  d="M19.9923 28.911L20.0091 28.911"
                  stroke="#214C9F"
                  stroke-width="2.4998"
                  stroke-linecap="square"
                />
              </g>
            </svg>

            {{ $t("dialog.sessionExpired.title") }}
          </h2>

          <div
            class="text-secondary flex w-full flex-col gap-4 text-base font-medium"
            v-html="$t('dialog.sessionExpired.description')"
          />
        </div>

        <Button variant="secondary" class="mx-auto max-w-fit" @click="redirectionToJoinFidPage">
          {{ $t("dialog.sessionExpired.cta") }}
        </Button>
      </div>
    </template>
  </Dialog>
</template>
